import { TLegalListItem } from 'shared/types/legalPages.interface';

export const ConsentProcessingLists: TLegalListItem[] = [
  {
    description: 'What personal data we collect and why.',
  },
  {
    description: 'How we use, store, and share your data.',
  },
  {
    description:
      'Your rights regarding your personal data (including access, deletion, correction, ' +
      'and opt-out rights under GDPR and CCPA).',
  },
  {
    description: 'How to exercise those rights and expected response timeframes.',
  },
];
